import { Box, styled } from '@mui/material';
import React from 'react';

interface ArticleContentProps {
  url: string;
}

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  overflowX: 'hidden',
}));

const StyledIframe = styled('iframe')(() => ({
  width: '100%',
  border: 'none',
  flexGrow: 1,
}));

export const ArticleContent = ({ url }: ArticleContentProps) => (
  <StyledBox>
    <StyledIframe
      id="article-iframe"
      src={url}
      width="100%"
      height="100%"
      title="External Content"
    />
  </StyledBox>
);
